module.exports = __webpack_public_path__ + "img/silvery-order.fc3f4bd.png";